export const tabQueryParam = 'tab';
export const pgQueryParam = 'pg';
export const searchInputQueryParam = 'q';
export const searchTypeQueryParam = 'searchType';
export const resourceTypeParam = 'resourceType';
export const typeSearchDelay = 500;
export const hiddenClass = 'hidden';
export const searchButtonHiddenClass = 'search-button-hidden';
export const invisibleClass = 'invisible';
export const showClearAllButton = 'show-clear-all-button';
export const disabledWrapperClass = 'disabled-wrapper';
export const corporateDocsValue = 'corporate-documents';
export const displayDateFormat = 'dd/MM/yyyy';
export const submissionDateFormat = 'dd MMMM yyyy';
export const serverDateTimeFormat = 'yyyy/MM/dd HH:mm';
export const serverDateTimeSecondsFormat = 'yyyy-MM-dd HH:mm:ss';
export const friendlyDateFormat = 'd MMM yyyy';

export const removeClass = (element, className) => {
    if (element) {
        element.classList.remove(className);
    }
}

export const addClass = (element, className) => {
    if (element) {
        element.classList.add(className);
    }
}
